function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export default function NoiceIconFilled(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        fill: "none",
        viewBox: "0 0 73 56",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "53.6451",
                x2: "62.659",
                y1: "52.2713",
                y2: "1.10501",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".06",
                        stopColor: "#5231f9"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".32",
                        stopColor: "#6c2cfc"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".68",
                        stopColor: "#bb12fc"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".77",
                        stopColor: "#cf0bf9"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".94",
                        stopColor: "#ef00f5"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("linearGradient", {
                id: "b",
                gradientUnits: "userSpaceOnUse",
                x1: "4.96827",
                x2: "48.0976",
                y1: "16.2937",
                y2: "59.4718",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".36",
                        stopColor: "#3ceb18"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".95",
                        stopColor: "#00eae8"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("radialGradient", {
                id: "c",
                cx: "0",
                cy: "0",
                gradientTransform: "matrix(28.4366 0 0 28.406 5.11776 51.0883)",
                gradientUnits: "userSpaceOnUse",
                r: "1",
                children: [
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".24",
                        stopColor: "#2fcc0e"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".44",
                        stopColor: "#2fcc0e",
                        stopOpacity: ".65"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".65",
                        stopColor: "#2fcc0e",
                        stopOpacity: ".3"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".8",
                        stopColor: "#2fcc0e",
                        stopOpacity: ".08"
                    }),
                    /*#__PURE__*/ _jsx("stop", {
                        offset: ".88",
                        stopColor: "#2fcc0e",
                        stopOpacity: "0"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("clipPath", {
                id: "d",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "m0 0h73v56h-73z"
                })
            }),
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#d)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "m59.0503.854001c-2.1723.387329-3.1697 1.850329-3.1697 6.677999 0 29.218-6.5101 37.0113-10.0255 37.0113-2.3662 0-3.1978-2.114-3.4594-3.143 2.3966 12.0074 10.7075 11.7904 15.2811 8.5027 1.6141-1.5797 3.2328-3.5093 4.8049-5.831 8.3063-12.257 10.4389-22.9927 10.516-29.7827.0911-7.8703-8.7641-14.3569658-13.9474-13.435299z",
                        fill: "url(#a)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "m42.3956 41.4003c-.035-.182-.0701-.364-.1051-.5506-2.6956-15.0454-1.4739-40.8497-15.0989-40.8497-19.51141 0-26.983794 41.6337-27.19168445 51.6437-.04204535 1.9856 1.22632445 3.808 3.22814445 4.249 1.94576.427 3.87284-.5927 4.65068-2.3427.11212-.2543 7.80176-23.541 15.41426-23.541 10.0232 0 9.3131 25.991 23.0642 25.991 3.3753 0 6.8674-1.743 11.3172-6.097-4.5736 3.2877-12.8845 3.5047-15.2811-8.5027z",
                        fill: "url(#b)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "m42.3956 41.4003c-.035-.182-.0701-.364-.1051-.5506-2.6956-15.0454-1.4739-40.8497-15.0989-40.8497-19.51141 0-26.983794 41.6337-27.19168445 51.6437-.04204535 1.9856 1.22632445 3.808 3.22814445 4.249 1.94576.427 3.87284-.5927 4.65068-2.3427.11212-.2543 7.80176-23.541 15.41426-23.541 10.0232 0 9.3131 25.991 23.0642 25.991 3.3753 0 6.8674-1.743 11.3172-6.097-4.5736 3.2877-12.8845 3.5047-15.2811-8.5027z",
                        fill: "url(#c)"
                    })
                ]
            })
        ]
    }));
}
